export default "__VITE_ASSET__B4AGvUk3__"